import './components'
import './extends'

const VALIDATE =
  async context => (await context.$refs ?
    context.$refs.observer.validate() :
    context.refs.observer.validate())
export { VALIDATE }
